import ReactDOM from 'react-dom';
import TagManager from 'react-gtm-module';

// import { hotjar } from 'react-hotjar';
import { App } from 'app/modules/App';
import reportWebVitals from 'pkg/config/reportWebVitals';
import { worker } from 'pkg/test/api/worker';

import './semantic-ui/semantic-config.less';

if (process.env.REACT_APP_GTM_ID) {
  TagManager.initialize({ gtmId: process.env.REACT_APP_GTM_ID });
} else {
  throw new Error('Google Tag manager env variable is not specified! Please look at README.md file');
}

if (process.env.REACT_APP_MOCK_API === 'true') {
  worker.start({ onUnhandledRequest: 'bypass' });
}

// if (process.env.REACT_APP_HOTJAR_ID && process.env.REACT_APP_HOTJAR_SNIPPET_VERSION) {
//   const hjid = Number(process.env.REACT_APP_HOTJAR_ID);
//   const hjsv = Number(process.env.REACT_APP_HOTJAR_SNIPPET_VERSION);
//   hotjar.initialize(hjid, hjsv);
// } else {
//   throw new Error('Hotjar env variables are not specified! Please look at README.md file');
// }

ReactDOM.render(<App />, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
